<template>
  <div class="fade-in">
    <h1 class="title">Create a Account</h1>

    <form @submit.prevent="onSubmit" class="column is-two-thirds-desktop">
      <formly-form
        v-if="optionsReady"
        :form="form"
        :model="practice"
        :fields="fields"
      ></formly-form>

      <div class="field is-grouped mt2">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            Create
          </button>
        </div>
        <div class="control">
          <router-link :to="{ name: 'practice-list' }" class="button is-link"
            >Cancel</router-link
          >
        </div>
      </div>
    </form>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import _ from "lodash";
import VueToastr from "vue-toastr";
import PracticesService from "@/services/PracticesService";
import fields from "@/components/practice/fields";

export default {
  name: "practice-create",

  mixins: [fields],

  components: {
    VueToastr
  },

  data() {
    return {
      loading: false,
      optionsReady: false,
      practice: {
        parentId: "",
        name: "",
        subdomain: "",
        timezone: "",
        primaryColor: "#ffffff",
        secondaryColor: "#000000",
        productTable: [{ productCode: null, quantity: 1, price: 1000 }]
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      PracticesService.create(this.practice)
        .then(() => {
          this.loading = false;
          this.$refs.toastr.s("The practice has been created.");
          setTimeout(() => {
            this.$router.push({ name: "practice-list" });
          }, 2000);
        })
        .catch(errors => {
          this.loading = false;
          this.$refs.toastr.e("There was an error creating the practice.");
          this.setErrors(errors);
        });
    },
    getPractices() {
      return new Promise(resolve => {
        const practices = this.$store.getters["practice/list"];
        resolve(practices);
      });
    }
  },

  mounted() {
    this.getPractices().then(practices => {
      const index = _.findIndex(this.fields, ["key", "parentId"]);
      const practiceOptions = this.getPracticeOptions(practices);
      this.fields[index].options = this.fields[index].options.concat(
        practiceOptions
      );
    });
    this.setTimezones();
    this.optionsReady = true;
  }
};
</script>

<style lang="scss"></style>
